import { Component } from '@angular/core';
import { SecondaryPageComponent } from '../../secondary-page/secondary-page.component';

@Component({
  selector: 'app-travel',
  standalone: true,
  imports: [],
  templateUrl: './travel.component.html',
  styleUrl: './travel.component.scss'
})
export class TravelComponent extends SecondaryPageComponent {

}
